import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface SettingsFieldStackProps {
	children: ReactNode
	className?: string
}

/**
 * Wrapper component for consistent vertical spacing in settings forms.
 * Provides 0.75rem (gap-3) spacing between field rows to match SectionHeading mb-3.
 */
export function SettingsFieldStack({ children, className }: SettingsFieldStackProps) {
	return (
		<div className={cn('flex flex-col gap-3', className)}>
			{children}
		</div>
	)
}
